
































































































import Vue from 'vue';
import Component from 'vue-class-component';
import TextInput from '@/components/TextInput.vue';
import StatusTracker from '@/components/StatusTracker.vue';
import { mapGetters } from 'vuex';
import { mapModelLike } from '@/store/util';
import MatrixStatsBoxHeaderAddon from '@/components/boxes/MatrixStatsBoxHeaderAddon.vue';

@Component({
  components: { StatusTracker, TextInput },
  computed: {
    ...mapGetters('matrix', ['totalHealth', 'damageModifier']),
    ...mapModelLike('matrix', [
      'simHot',
      'attack',
      'sleaze',
      'dataProcessing',
      'firewall',
      'deviceName',
      'deviceRating',
      'programs',
      'damage',
    ]),
  },
})
export default class MatrixStatsBox extends Vue {
  static defaultHeight = 8;

  static optional = true;

  static HeaderAddon = MatrixStatsBoxHeaderAddon;

  get availablePrograms() {
    // const installedPrograms = this.$store.state.matrix.programs;
    return Object.values(this.$t('matrix.availablePrograms'));
    //      .filter((e: string) => installedPrograms.indexOf(e) > -1);
  }
}
